module.exports = __webpack_public_path__ + "media/images/icons/outlined/diff-57986b1af3c6ea2708ba17fbcf1e833c.svg";